import { Component } from "react";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../../actions/fillCombo_action';
import { cityActionId, stallTypeActionId, stallListActionId, countryActionId, exhibitionActionId, toastError, toastSuccess, mainChapterListActionId, exhibitionOtherAreaActionId, gateActionId } from "../../../../utils/constants";
import DatePicker from "react-datepicker";
import Select from 'react-select';

import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import Pagination from "../../../../utils/pagination";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import { getHallMasterDetails_action, insertUpdateHallMaster_action } from "../../../../actions/admin_module_action/master_action/hall_master_action";
import Footer from "../../../../common_components/Footer";
import { ThirtyFpsSelect } from "@mui/icons-material";


class HallMasterAU extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            currentPage: 1,
            exhibitionList: [],
            chapterList: [],
            selectedChapterList: [],
            is_add: false,
            is_update: false,
            exhibitionID: '',
            hallName: '',
            hallID: '',
            zoneList: [{ Zone: '', id: 1, ActionID: 1, HallZoneMappingID: null }],
            IsOtherArea: false,
            ExhibitionOtherAreaID: '',
            ExhibitionOtherAreaList: [],
            GateID: '',
            GateList: []
        }

        this.getFillList = this.getFillList.bind(this)
        this.getHallMasterDetails = this.getHallMasterDetails.bind(this)
        this.onPreviousClick = this.onPreviousClick.bind(this)
        this.insertHallMaster = this.insertHallMaster.bind(this)
        this.updateHallMaster = this.updateHallMaster.bind(this)
        this.onNextClick = this.onNextClick.bind(this)
        this.onExhibitionadd = this.onExhibitionadd.bind(this)
        this.handleSegmentSelection = this.handleSegmentSelection.bind(this)

    }

    componentDidMount() {
        this.getFillList(exhibitionActionId, '', '', '', '', '');
        this.getFillList(exhibitionOtherAreaActionId, '', '', '', '', '');
        this.getFillList(gateActionId, '', '', '', '', '');
        this.setState({
            is_add: this.props.location.state != null && this.props.location.state.is_add != null ? this.props.location.state.is_add : false,
            is_update: this.props.location.state != null && this.props.location.state.is_update != null ? this.props.location.state.is_update : false,
            hallID: this.props.location.state != null && this.props.location.state.hallID != null ? this.props.location.state.hallID : '',
            exhibitionID: this.props.location.state != null && this.props.location.state.exhibitionID != null ? this.props.location.state.exhibitionID : '',
        }, () => {
            this.state.is_update && this.getHallMasterDetails()

        })
    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
            .then((data) => {
                if (data.error != 1) {
                    // country list
                    if (actionID === exhibitionActionId) {
                        this.setState({
                            exhibitionList: data.data
                        })
                    }
                    if (actionID === mainChapterListActionId) {
                        this.setState({
                            chapterList: data.data
                        })
                    }
                    if (actionID === exhibitionOtherAreaActionId) {
                        this.setState({
                            ExhibitionOtherAreaList: data.data
                        })
                    }
                    if (actionID === gateActionId) {
                        this.setState({
                            GateList: data.data
                        })
                    }
                }
                this.setState({ isLoading: false })
            })
            .catch((e) => {
                console.log(e);
            });
    }

    getHallMasterDetails() {
        this.setState({ isLoading: true })
        const { exhibitionID, hallID, selectedChapterList } = this.state
        this.props.getHallMasterDetails_action(exhibitionID, hallID)
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data[1])
                    for (var i = 0; i < data.data[1].length; i++) {
                        var obj = { label: data.data[1][i].ChapterName, value: data.data[1][i].ChapterID }
                        selectedChapterList.push(obj)
                    }
                    if (data.data[2].length > 0) {
                        data.data[2].map(item => {
                            item.ActionID = 2
                        })
                        this.setState({ zoneList: data.data[2] })
                    } else {
                        this.setState({ zoneList: [{ Zone: '', id: 1, ActionID: 1, HallZoneMappingID: null, IsOtherArea: false }] })
                    }

                    this.setState({
                        hallName: data.data[0][0].HallName,
                        IsOtherArea: data.data[0][0].IsOtherArea,
                        ExhibitionOtherAreaID: data.data[0][0].ExhibitionOtherAreaID,
                        GateID: data.data[0][0].GateID,
                    })
                    // this.setState({ exhibitionID: data.data[0][0].ExhibitionID })
                    this.onExhibitionadd(data.data[0][0].ExhibitionID)
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onPreviousClick() {
        this.props.navigate('/hallMasterList',)
    }

    insertHallMaster() {
        const { isLoading, exhibitionID, hallName, is_update, selectedChapterList, zoneList, IsOtherArea, ExhibitionOtherAreaID, GateID } = this.state
        console.log("GateID-->", GateID)
        const isValidate = zoneList.filter(obj => obj.ActionID != 3).every(item => item.Zone?.trim() !== '');
        const isDuplicate = this.checkDuplicates(zoneList, "Zone");
        const isOtherAreaValidate = zoneList.filter(obj => obj.ActionID != 3).some(item => item.IsOtherArea && (item.ExhibitionOtherAreaID == '' || item.ExhibitionOtherAreaID == null));
        if (IsOtherArea && (ExhibitionOtherAreaID == '' || ExhibitionOtherAreaID == null) || isOtherAreaValidate) {
            return toastError("Please select Area Type")
        }
        if (exhibitionID != '' && exhibitionID != null && hallName != '' && hallName != null && GateID != '' && GateID != null) {
            if (!IsOtherArea ? selectedChapterList.length > 0 : true) {
                if (isValidate) {
                    if (isDuplicate) {
                        this.setState({ isLoading: true })
                        this.props.insertUpdateHallMaster_action(exhibitionID, hallName, null, selectedChapterList, zoneList, IsOtherArea, ExhibitionOtherAreaID, GateID)
                            .then((data) => {
                                if (data.error != 1) {
                                    console.log(data.data)
                                    this.setState({ isLoading: false })
                                    toastSuccess("added successfully")
                                    this.props.navigate('/hallMasterList',)
                                }
                                else {
                                    this.setState({ isLoading: false })
                                    toastError(data.msg)
                                }
                            })
                            .catch((err) => {
                                console.log(err)
                            })
                    } else {
                        toastError("Duplicate zones are not allowed.")
                    }
                } else {
                    toastError("Please fill in all sections of the table.")
                }
            }
            else {
                toastError("Please select atleast 1 segment")
            }
        }
        else {
            toastError("Please enter mandatory fields")
        }
    }

    checkDuplicates(arr, key) {
        const seen = new Set();
        for (let obj of arr) {
            // Ignore if ActionID === 3
            if (obj.ActionID === 3) continue;
            if (seen.has(obj[key])) {
                return false; // duplicate found
            }
            seen.add(obj[key]);
        }
        return true; // no duplicates
    }


    updateHallMaster() {
        const { isLoading, exhibitionID, hallName, is_update, selectedChapterList, zoneList, IsOtherArea, ExhibitionOtherAreaID, GateID } = this.state
        const { hallID } = this.state
        console.log("zoneList", zoneList)
        const isValidate = zoneList.filter(obj => obj.ActionID != 3).every(item => item.Zone?.trim() !== '');
        const isDuplicate = this.checkDuplicates(zoneList, "Zone");
        console.log("isDuplicate", isDuplicate)
        const isOtherAreaValidate = zoneList.filter(obj => obj.ActionID != 3).some(item => item.IsOtherArea && (item.ExhibitionOtherAreaID == '' || item.ExhibitionOtherAreaID == null));
        if (IsOtherArea && (ExhibitionOtherAreaID == '' || ExhibitionOtherAreaID == null) || isOtherAreaValidate) {
            return toastError("Please select Area Type")
        }
        if (exhibitionID != '' && exhibitionID != null && hallName != '' && hallName != null && hallID != null && hallID != '' && GateID != null && GateID != '') {
            if (!IsOtherArea ? selectedChapterList.length > 0 : true) {
                if (isValidate) {
                    if (isDuplicate) {
                        this.setState({ isLoading: true })
                        this.props.insertUpdateHallMaster_action(exhibitionID, hallName, hallID, selectedChapterList, zoneList, IsOtherArea, ExhibitionOtherAreaID, GateID)
                            .then((data) => {
                                if (data.error != 1) {
                                    console.log(data.data)
                                    this.props.navigate('/hallMasterList',)
                                    toastSuccess("update successful")
                                    this.setState({ isLoading: false })
                                }
                                else {
                                    this.setState({ isLoading: false })
                                    toastError(data.msg)
                                }
                            })
                            .catch((err) => {
                                console.log(err)
                            })
                    } else {
                        toastError("Duplicate zones are not allowed.")
                    }
                } else {
                    toastError("Please fill in all sections of the table.")
                }
            }
            else {
                toastError("Please select atleast 1 segment")
            }
        }
        else {
            toastError("Please enter mandatory fields")
        }
    }

    onNextClick() {
        const { is_update } = this.state;
        if (is_update == true) {
            this.updateHallMaster();
        } else {
            this.insertHallMaster();
        }
    }

    onExhibitionadd(val) {
        this.setState({ exhibitionID: val })
        this.getFillList(mainChapterListActionId, val, '', '', '', '');

    }

    handleSegmentSelection(e) {
        console.log("111111111111111111111", e)
        this.setState({ selectedChapterList: e })
    }

    handleInput(index, e, type) {
        const { zoneList } = this.state
        zoneList.forEach((item, i) => {
            if (index == i) {
                if (type == 'checkbox') {
                    item.IsOtherArea = e.target.checked
                    if (!e.target.checked) {
                        item.ExhibitionOtherAreaID = ''
                    }
                } else if (type == 'varchar') {
                    item.Zone = e.target.value
                } else {
                    item.ExhibitionOtherAreaID = e.target.value
                }
            }
        })
        this.setState({ zoneList: zoneList })
    }

    handleClear(index) {
        const { zoneList } = this.state
        zoneList.forEach((item, i) => {
            if (index == i) {
                item.Zone = ''
            }
        })
        this.setState({ zoneList: zoneList })
    }

    handleRemove(index) {
        const { zoneList } = this.state
        zoneList.forEach((item, i) => {
            if (index == i) {
                item.ActionID = 3
            }
        })
        this.setState({ zoneList: zoneList })
    }

    render() {
        const { isLoading, exhibitionID, currentPage, hallMasterList, is_add, exhibitionList, hallName, zoneList, IsOtherArea, ExhibitionOtherAreaID, ExhibitionOtherAreaList, GateID, GateList } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <div className="app-content with-dr-container com-height">
                        <AdminDrawer />

                        <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                                <p className="mb-0 p-2 text-white">Hall {is_add ? 'Add' : 'Update'}</p>
                            </div>
                        </div>
                        {/* <div className="app-content with-dr-container com-height"> */}
                        <div className="admin-top-space p-2">
                            <div className="row m-0">
                                <div className="col-md-4">
                                    <label>Exhibition <span className="text-red">*</span></label>
                                    <select className="form-control"
                                        value={exhibitionID}
                                        onChange={(e) => this.onExhibitionadd(e.target.value)}  >
                                        <option value={''}>Select</option>
                                        {
                                            exhibitionList.length > 0 && exhibitionList.map(data => (
                                                <option value={data.ExhibitionID} key={data.ExhibitionID}>{data.ExhibitionName}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <label>Hall Name <span className="text-red">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={hallName}
                                        onChange={(e) => this.setState({ hallName: e.target.value, })}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label>Gate <span className="text-red">*</span></label>
                                    <select className="form-control"
                                        value={GateID}
                                        onChange={(e) => this.setState({ GateID: e.target.value })}  >
                                        <option value={''}>Select</option>
                                        {
                                            GateList.length > 0 && GateList.map(data => (
                                                <option value={data.GateID} key={data.GateName}>{data.GateName}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                                <div className="col-md-8"
                                    style={{ padding: "9px!important" }}
                                >
                                    <label className="" style={{ fontSize: 14 }}>
                                        Segment {!IsOtherArea && <span className="text-red">*</span>}
                                    </label>
                                    <Select
                                        options={this.state.chapterList.map((option) => ({ label: option.ChapterName, value: option.ChapterID }))}
                                        value={this.state.selectedChapterList}
                                        onChange={this.handleSegmentSelection}
                                        isMulti
                                    />
                                </div>
                                <div
                                    className="col-md-4"
                                    style={{ padding: "9px!important" }}
                                >
                                    <label></label>
                                    <div className="d-flex">
                                        <div className="d-flex mt-2" style={{ width: '50%' }}>
                                            <input
                                                type="checkbox"
                                                className=""
                                                checked={IsOtherArea}
                                                onChange={(e) => this.setState({ IsOtherArea: e.target.checked, ExhibitionOtherAreaID: e.target.checked ? ExhibitionOtherAreaID : '' })}
                                            />
                                            <div >
                                                <label htmlFor="identifier-1" style={{ fontSize: 16 }} className="">
                                                    Is Other Area
                                                </label>
                                            </div>
                                        </div>
                                        {IsOtherArea &&
                                            <div style={{ width: '80%' }}>
                                                <select className="form-control"
                                                    value={ExhibitionOtherAreaID}
                                                    onChange={(e) => this.setState({ ExhibitionOtherAreaID: e.target.value })}  >
                                                    <option value={''}>Select Area Type</option>
                                                    {
                                                        ExhibitionOtherAreaList.length > 0 && ExhibitionOtherAreaList.map(data => (
                                                            <option value={data.ExhibitionOtherAreaID} key={data.ExhibitionOtherAreaID}>{data.Name}</option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div
                                    className="col-md-8"
                                    style={{ padding: "9px!important" }}
                                >
                                    <div className="d-flex justify-content-between align-items-center mt-2">
                                        <h6 className="text-primary mb-0"></h6>
                                        <button
                                            className="btn btn-aqua px-2 p-1"
                                            id="addPricingBtn"
                                            onClick={() =>
                                                this.setState(prev => ({
                                                    zoneList: [...prev.zoneList, { Zone: '', id: zoneList.length + 1, ActionID: 1, HallZoneMappingID: null, IsOtherArea: false, ExhibitionOtherAreaID: '' }]
                                                }))
                                            }

                                        >
                                            Add More
                                        </button>
                                    </div>
                                    <h6 className=" text-primary" />
                                    <table
                                        className="table table-bordered  align-middle mb-4"
                                        id="pricingTable"
                                    >
                                        <thead className="table-light">
                                            <tr>
                                                <th className="text-left">Zone</th>
                                                <th className="text-center" style={{ width: '210px' }}>Is Other Area</th>
                                                <th className="text-center" style={{ width: '10px' }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {zoneList.map((item, index) => (
                                                <>
                                                    {item.ActionID != 3 &&
                                                        <tr>
                                                            <td className="text-right">
                                                                <input
                                                                    className="form-control"
                                                                    value={item.Zone}
                                                                    onChange={(e) => this.handleInput(index, e, 'varchar')}
                                                                />
                                                            </td>
                                                            <td className="text-center">

                                                                <div className="d-flex justify-content-center">
                                                                    <div className="mt-2">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={item.IsOtherArea}
                                                                            onChange={(e) => this.handleInput(index, e, 'checkbox')}
                                                                        />
                                                                    </div>
                                                                    {item.IsOtherArea &&
                                                                        <div>
                                                                            <select className="form-control"
                                                                                value={item.ExhibitionOtherAreaID}
                                                                                onChange={(e) => this.handleInput(index, e, 'IsOtherArea')}
                                                                            >
                                                                                <option value={''}>Select Area Type</option>
                                                                                {
                                                                                    ExhibitionOtherAreaList.length > 0 && ExhibitionOtherAreaList.map(data => (
                                                                                        <option value={data.ExhibitionOtherAreaID} key={data.ExhibitionOtherAreaID}>{data.Name}</option>
                                                                                    ))
                                                                                }
                                                                            </select>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </td>
                                                            <td className="text-center">
                                                                {/* Clear Button */}
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-aqua"
                                                                    onClick={() => this.handleClear(index)}
                                                                >
                                                                    Clear
                                                                </button>

                                                                {/* Delete Button – show only when more than 1 item */}
                                                                {zoneList.filter(obj => obj.ActionID !== 3).length > 1 && (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-outline-danger btn-sm ms-1"
                                                                        onClick={() => this.handleRemove(index)}
                                                                    >
                                                                        Delete
                                                                    </button>
                                                                )}
                                                            </td>

                                                        </tr>
                                                    }
                                                </>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            < div className="row mt-2" >
                                <div className="col-md-12">
                                    <div className="main-container container-fluid p-2 pt-0 pb-0">
                                        <div className="mt-1 mb-4 text-end">
                                            {
                                                sessionStorage.getItem("sessionExhRegistrationID") == null &&
                                                <button className="btn btn-aqua" onClick={e => this.onNextClick()}>
                                                    {" "}
                                                    Save{" "}
                                                </button>
                                            }

                                            <button className="btn btn-gray mx-2" onClick={e => this.onPreviousClick()} >
                                                Back
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        {/* </div> */}
                    </div>
                </>
                <Footer />
            </>)
    }

}
export default withRouter(connect(null, { fill_action, getHallMasterDetails_action, insertUpdateHallMaster_action })(HallMasterAU));